// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import { AuthProvider } from './AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import Home from './pages/Home';
import ICVForm from './pages/ICVForm';
import RelatorioICV from './pages/RelatorioICV';
import Plano30Dias from './pages/Plano30Dias';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import AdminConvites from './pages/AdminConvites';
import AdminUsuarios from './pages/AdminUsuarios';
import AdminAcompanhamentos from './pages/AdminAcompanhamentos';
import CoachDashboard from './pages/CoachDashboard';
import CoachParticipante from './pages/CoachParticipante';
import CoachParticipantes from './pages/CoachParticipantes';
import ParticipanteDashboard from './pages/ParticipanteDashboard';
import ParticipanteAvaliacoes from './pages/ParticipanteAvaliacoes';
import ConviteParticipante from './pages/ConviteParticipante';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/convite/:token"
            element={<ConviteParticipante />}
          />

          <Route path="/" element={<Home />} />
          <Route path="/icv" element={<ICVForm />} />

          <Route
            path="/relatorio-icv"
            element={<RelatorioICV />}
          />

          <Route
            path="/plano-30-dias"
            element={<Plano30Dias />}
          />

          <Route
            path="/admin"
            element={
              <ProtectedRoute roles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/convites"
            element={
              <ProtectedRoute roles={['admin']}>
                <AdminConvites />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/usuarios"
            element={
              <ProtectedRoute roles={['admin']}>
                <AdminUsuarios />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/acompanhamentos"
            element={
              <ProtectedRoute roles={['admin']}>
                <AdminAcompanhamentos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/participante"
            element={
              <ProtectedRoute roles={['participante']}>
                <ParticipanteDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/participante/avaliacoes"
            element={
              <ProtectedRoute roles={['participante']}>
                <ParticipanteAvaliacoes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coach/participantes"
            element={
              <ProtectedRoute roles={['coach']}>
                <CoachParticipantes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coach/participantes/:participantId"
            element={
              <ProtectedRoute roles={['coach']}>
                <CoachParticipante />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coach"
            element={
              <ProtectedRoute roles={['coach']}>
                <CoachDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="*"
            element={<Navigate to="/" replace />}
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;










